import $ from 'jquery'
import { algoliasearch } from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import { highlight } from 'instantsearch.js/es/helpers'
import { configure, index } from 'instantsearch.js/es/widgets'
import { history } from 'instantsearch.js/es/lib/routers'
import { connectSearchBox, connectHits } from 'instantsearch.js/es/connectors'

import {
  algoliaAppId,
  algoliaApiKey,
  boatSearchIndex,
  boatSearchSuggestionsIndex,
  productSearchIndex,
  productSearchSuggestionsIndex,
} from '../variables'

import { boatHit, productHit, noResult, allProducts } from '../templates'
import headerSearchBox from '../components/headerSearchBox'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n
const object = vnObject

const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)
const myNavbar = $('.header-search')

// 🔁 Widget personnalisé pour fusionner les résultats des deux index
const mixedHits = (widgetParams) => ({
  init({ helper }) {
    const container = document.querySelector(widgetParams.container)

    const renderHits = (allHits) => {
      container.innerHTML = allHits.length
        ? allHits
            .map((hit) => {
              return hit.__indexName === boatSearchIndex
                ? boatHit(hit, 'g-col-12 g-col-lg-4') // Utilise ton template pour les bateaux
                : productHit(hit, 'g-col-12 g-col-lg-4') // Utilise ton template pour les produits
            })
            .join('')
        : noResult
    }

    const fetchHits = () => {
      const query = helper.state.query || ''

      searchClient
        .search([
          {
            indexName: boatSearchIndex,
            query,
            params: { hitsPerPage: 3 }, // Ajuste le nombre si besoin
          },
          {
            indexName: productSearchIndex,
            query,
            params: { hitsPerPage: 3 }, // Ajuste le nombre si besoin
          },
        ])
        .then(({ results }) => {
          let allHits = [
            ...results[0].hits.map((hit) => ({
              ...hit,
              __indexName: boatSearchIndex,
            })),
            ...results[1].hits.map((hit) => ({
              ...hit,
              __indexName: productSearchIndex,
            })),
          ]

          // Mélanger si tu veux un ordre aléatoire (optionnel)
          allHits = allHits.sort(() => Math.random() - 0.5)

          // Limiter à 3 résultats max
          allHits = allHits.slice(0, 3)

          renderHits(allHits)
        })
    }

    fetchHits()

    helper.on('change', fetchHits)
  },
})

// 🔁 Widget personnalisé pour fusionner les suggestions des deux indices
const mixedSuggestions = (widgetParams) => ({
  init({ helper }) {
    const container = document.querySelector(widgetParams.container)

    const renderHits = (allHits) => {
      container.innerHTML = allHits.length
        ? allHits
            .map((hit) => {
              return hit.__indexName === boatSearchSuggestionsIndex
                ? `
                <a href="${object.boatsPage}${object.algoliaQueryStrings.query}/${hit.query}" class="feed-algolia-link">
                  <i class="vn-icons-search"></i>
                  <div class="feed-algolia-link__title">${hit._highlightResult.query.value}</div>
                  <i class="vn-icons-back_arrow"></i>
                </a>
              `
                : `
                <a href="${object.productsPage}${object.algoliaQueryStrings.query}/${hit.query}" class="feed-algolia-link">
                  <i class="vn-icons-search"></i>
                  <div class="feed-algolia-link__title">${hit._highlightResult.query.value}</div>
                  <i class="vn-icons-back_arrow"></i>
                </a>
              `
            })
            .join('')
        : noResult
    }

    const fetchHits = () => {
      const query = helper.state.query || ''

      searchClient
        .search([
          {
            indexName: boatSearchSuggestionsIndex,
            query,
            params: { hitsPerPage: 3 }, // Ajuste le nombre de suggestions
          },
          {
            indexName: productSearchSuggestionsIndex,
            query,
            params: { hitsPerPage: 3 }, // Ajuste le nombre de suggestions
          },
        ])
        .then(({ results }) => {
          let allHits = [
            ...results[0].hits.map((hit) => ({
              ...hit,
              __indexName: boatSearchSuggestionsIndex,
            })),
            ...results[1].hits.map((hit) => ({
              ...hit,
              __indexName: productSearchSuggestionsIndex,
            })),
          ]

          // Mélanger si tu veux un ordre aléatoire (optionnel)
          allHits = allHits.sort(() => Math.random() - 0.5)

          // Limiter à 3 suggestions max
          allHits = allHits.slice(0, 6)

          renderHits(allHits)
        })
    }

    fetchHits()

    helper.on('change', fetchHits)
  },
})

const customSearchBox = connectSearchBox(headerSearchBox)

function createArchiveUrl(urlParams) {
  const formEL = document.querySelector('.js-header-search-form')
  const urlEl = $('.js-header-search-form').find('.all-products')
  const origUrl = urlEl.data('orig-href')
  let searchValue = ''

  if (headerSearch.helper != null) {
    searchValue = headerSearch.helper.getQuery().query
  }

  let finalUrl = origUrl

  if (searchValue != undefined && searchValue != '') {
    finalUrl += object.algoliaQueryStrings.query + '/' + searchValue + '/'
  }

  urlEl.attr('href', finalUrl)
  formEL.setAttribute('action', finalUrl)

  return finalUrl
}

// 🧠 INIT de la recherche
const headerSearch = instantsearch({
  indexName: boatSearchIndex,
  searchClient,
  insights: true,
  future: { preserveSharedStateOnUnmount: true },
  routing: {
    router: history({
      cleanUrlOnDispose: false,
      push(url) {
        const queryString = url.split('?')[1]
        const params = new URLSearchParams(queryString)
        const result = '?' + params.toString()
        createArchiveUrl(result)
      },
    }),
  },
  onStateChange(helper) {
    if (helper.state) {
      const isReset =
        Object.keys(helper.state.disjunctiveFacetsRefinements).length === 0 &&
        Object.keys(helper.state.hierarchicalFacetsRefinements).length === 0 &&
        Object.keys(helper.state.facetsRefinements).length === 0 &&
        !helper.state.query

      if (isReset) {
        createArchiveUrl('')
      }
      helper.search()
    }
  },
})

if (myNavbar.length) {
  headerSearch.addWidgets([
    customSearchBox({
      container: '.js-search-handler',
      placeholder: __('Search a product ...', 'vn'),
      showLoadingIndicator: false,
    }),

    mixedHits({
      container: '.header-search-hits',
    }),

    configure({
      hitsPerPage: 6,
    }),

    // Utilisation de mixedSuggestions pour combiner les suggestions
    mixedSuggestions({
      container: '.header-search-suggestions',
    }),
  ])

  headerSearch.start()

  const allProductsBtn = `
    <a href="${object.productsPage}" data-orig-href="${object.productsPage}" class="all-products g-col-12">
      <span class="all-products__title">${__('See all products', 'vn')}</span>
    </a>
  `
  $('.header-search__section').after(allProductsBtn)
}

$('.all-products').on('click', (e) => {
  e.preventDefault()
  const inputHandler = $('.js-search-handler');
  const finalUrl = createArchiveUrl(window.location.href + "/search/" + inputHandler.val());
  window.location.href = finalUrl
});

$('.js-header-search-form').on('submit', function (e) {
  e.preventDefault()
  const inputHandler = $('.js-search-handler');
  const finalUrl = createArchiveUrl(window.location.href + "/search/" + inputHandler.val());
  window.location.href = finalUrl
})

createArchiveUrl('')

export { headerSearch, createArchiveUrl }
